var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCheckbox16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.889 10.076 3.127 7.184a1.01 1.01 0 1 0-1.46 1.396L5.3 12.383a.815.815 0 0 0 1.178 0l7.856-8.223a1.01 1.01 0 0 0-1.461-1.395z"
})));
export default SvgIcCheckbox16;